import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Bokningsförfrågan", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Tack för din bokningsförfrågan. Vi återkommer till dig så snart som möjligt. ", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4 mb-3" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-4 mb-3" }
const _hoisted_11 = { class: "col-md-4 mb-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-4 mb-3" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", null, "Önskemål på annonser", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, "Storlek"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, "Antal"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" })
], -1)
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ad_nav = _resolveComponent("ad-nav")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_field_errors = _resolveComponent("field-errors")!
  const _component_fa = _resolveComponent("fa")!
  const _component_loadspinner = _resolveComponent("loadspinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_ad_nav),
    (_ctx.state.sent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.state.sent)
      ? (_openBlock(), _createElementBlock("form", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_text_field, {
                label: "Företag",
                modelValue: _ctx.state.form.company,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.form.company) = $event)),
                onInput: _ctx.validate
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_field_errors, {
                errors: _ctx.state.errors,
                field: "company"
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_text_field, {
                label: "Organisationsnummer",
                modelValue: _ctx.state.form.organizationalNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.organizationalNumber) = $event)),
                onInput: _ctx.validate
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_field_errors, {
                errors: _ctx.state.errors,
                field: "organizationalNumber"
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_text_field, {
                label: "Kontaktperson",
                modelValue: _ctx.state.form.contact,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.form.contact) = $event)),
                onInput: _ctx.validate
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_field_errors, {
                errors: _ctx.state.errors,
                field: "contact"
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_text_field, {
                label: "E-postadress",
                modelValue: _ctx.state.form.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.form.email) = $event)),
                onInput: _ctx.validate
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_field_errors, {
                errors: _ctx.state.errors,
                field: "email"
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_text_field, {
                label: "Telefon",
                modelValue: _ctx.state.form.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.form.phone) = $event)),
                onInput: _ctx.validate
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_field_errors, {
                errors: _ctx.state.errors,
                field: "phone"
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.options, (o, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row mt-2",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((o.size) = $event)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.adformats, (f, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: f.description,
                          key: i
                        }, _toDisplayString(f.description), 9, _hoisted_20))
                      }), 128))
                    ], 8, _hoisted_19), [
                      [_vModelSelect, o.size]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((o.count) = $event)
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (v, i) => {
                        return _createElementVNode("option", {
                          value: v,
                          key: i
                        }, _toDisplayString(v), 9, _hoisted_23)
                      }), 64))
                    ], 8, _hoisted_22), [
                      [_vModelSelect, o.count]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary btn-sm",
                      onClick: ($event: any) => (_ctx.removeOption(o))
                    }, [
                      _createVNode(_component_fa, {
                        icon: "minus",
                        width: "10",
                        class: "card-icon"
                      })
                    ], 8, _hoisted_25)
                  ])
                ]))
              }), 128)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary btn-sm mt-2",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addOption && _ctx.addOption(...args)))
              }, [
                _createVNode(_component_fa, {
                  icon: "plus",
                  width: "10",
                  class: "card-icon"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.hasErrors || _ctx.state.busy,
                class: "btn btn-primary mt-3",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
              }, " Skicka förfrågan ", 8, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_loadspinner, {
                message: "Skickar förfrågan...",
                loading: _ctx.state.busy
              }, null, 8, ["loading"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}